import { AngularLayout, FlexLayout } from '@rhtml/modifiers';
import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { ReactivumTheme } from '@shared/styles/theme';

/**
 * @customElement mission-component
 */
@Component({
  selector: 'mission-component',
  styles: [
    css`
      ${ReactivumTheme}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .mission-section {
        background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--border-light) 50%, var(--bg-tertiary) 100%);
        padding: 100px 0;
        text-align: center;
        position: relative;
      }

      .mission-content {
        max-width: 900px;
        margin: 0 auto;
      }

      .mission-title {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 30px;
        color: var(--text-primary);
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
      }

      .mission-text {
        font-size: 1.25rem;
        line-height: 1.7;
        color: var(--text-secondary);
        margin-bottom: 60px;
        font-weight: 400;
      }

      @media (max-width: 768px) {
        .mission-section {
          padding: 80px 0;
        }

        .mission-title {
          font-size: 2rem;
        }

        .mission-text {
          font-size: 1.1rem;
        }
      }
    `,
  ],
  modifiers: [...FlexLayout, ...AngularLayout],
  template() {
    return html`
      <section class="mission-section">
        <div class="container">
          <div class="mission-content">
            <h2 class="mission-title">Our Mission</h2>
            <p class="mission-text">
              We're committed to revolutionizing web development by providing tools and frameworks that prioritize
              developer experience, code quality, and system maintainability. Our solutions eliminate the pain points
              that have plagued the industry for years, allowing teams to focus on building great products instead of
              fighting with their tools.
            </p>
          </div>
        </div>
      </section>
    `;
  },
})
export class MissionComponent extends LitElement {}
